module.exports = "/images/illness-or-injury-background.png?8ed6e7c15300b42f5c3f7bab37315a52";